<template>
  <table>
    <thead>
      <tr>
        <th v-if="count" colspan="2">
          <b>{{$tc('transaction-results', count)}}</b> - {{$t('viewing')}} {{currentPage}} {{$t('of')}} {{count}}
          <span id="pagingButtons">
            <span @click="decrementCurrentPage" class="paging" :disabled="currentPage <= 1"> {{$t('previous')}} </span> -
            <span @click="incrementCurrentPage" class="paging" :disabled="currentPage >= count"> {{$t('next')}} </span>
          </span>
        </th>
        <th v-else>
          <b>{{$tc('transaction-results', count)}}</b>
        </th>
      </tr>
    </thead>
    <tbody v-if="count">
      <tr>
        <td> {{$t('transaction_id')}}: </td>
        <td> {{transactionData[currentPage-1].transaction_id}} </td>
      </tr>
      <tr>
        <td> {{$t('meter_number')}}: </td>
        <td> {{transactionData[currentPage-1].machine_number}} </td>
      </tr>
      <tr>
        <td> {{$t('transaction_date')}}: </td>
        <td> {{transactionData[currentPage-1].sale_date}} </td>
      </tr>
      <tr>
        <td> {{$t('amount')}}: </td>
        <td> ${{transactionData[currentPage-1].amount}} </td>
      </tr>
      <tr>
        <td> {{$t('session_start_time')}}: </td>
        <td> {{transactionData[currentPage-1].start_date}} </td>
      </tr>
      <tr>
        <td> {{$t('session_end_time')}}: </td>
        <td> {{transactionData[currentPage-1].end_date}} </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
    export default {
      name: "TransactionTable",
      props: {
        transactionData: {
          type: Array,
          required: true
        }
      },
      data() {
        return {
          currentPage: 1
        }
      },
      computed: {
        count () {
          return this.transactionData.length
        }
      },
      methods: {
        incrementCurrentPage() {
          if (this.currentPage) {
            this.currentPage = this.currentPage + 1;
          }
        },
        decrementCurrentPage() {
          if (this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
          }
        }
      }
    }
</script>

<style scoped>
  table {
    width: 100%;
    font-size: 14px;
  }

  th {
    text-align: left;
    font-weight: normal;
    border-bottom: 1px solid black;
    padding-bottom: 8px;
  }

  .paging {
    cursor: pointer;
  }

  .paging[disabled] {
    cursor: not-allowed;
    color: #798e94;
  }

  #pagingButtons {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/TransactionTable.vue